<script>
    import { topics } from "../services/store";
    import { _ } from "svelte-i18n";
    import { replace } from "svelte-spa-router";

    export let selectedLink, subTopic, list, mainTopic;

    function onClick(button) {
        replace("/" + selectedLink + "/" + mainTopic + "/" + button);
    }
</script>

<style>
    .selected {
        background-color: #d97706;
        border: 1px solid white;
        color: white;
    }
    .customShadow {
        box-shadow: 4px 4px 1px lightslategray;
    }
</style>

<div>
    {#if list}
        <div class="flex flex-wrap glass justify-center py-2">
            {#each list as b}
                <button
                    class:selected={subTopic.value === b}
                    class="leading-4 customShadow
                    p-2
           transition duration-500 ease-in-out uppercase
            text-gray-600  bg-transparent border rounded-full transform 
       hover:bg-accent-100 hover:-translate-y-1 hover:scale-110
       focus:bg-accent-100 focus:-translate-y-1 focus:scale-110
       "
                    on:click={onClick(b)}>
                    {$_(`topics.nav.${b}`)}
                </button>
            {/each}
        </div>
    {/if}
</div>
